import cx from "classnames";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";

import Icon from "common/components/Icon";

import styles from "../../styles/Checkbox.module.less";

type CheckboxProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  styles?: {
    container?: string;
    label?: string;
  };
};

const Checkbox = ({ value, onChange, label, styles: propStyles = {} }: CheckboxProps) => {
  return (
    <label className={cx(styles.container, propStyles.container)}>
      <span className={styles.box}>
        <input
          className={styles.checkbox}
          type="checkbox"
          checked={value}
          onChange={(event) => onChange(event.target.checked)}
        />
        {value && <Icon className={styles.icon} fixedWidth={true} icon={faCheck} />}
      </span>
      <span className={cx(styles.label, propStyles.label)}>{label}</span>
    </label>
  );
};

export default Checkbox;
